import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IoDocumentTextOutline } from "react-icons/io5";
import { GoDownload } from "react-icons/go";
import FilterToggle from "./FilterToggle";

const INITIAL_ROWS = 10;

const MonthlyReportSingle = ({
    currentUserId,
    filter,
    dateFrom,
    dateTo,
    data,
    onFilterChange,
    onCustomClick,
    onClearDates,
    onExport
}) => {
    const { t } = useTranslation();
    const [showAll, setShowAll] = useState(false);
    const totalEarned = data.reduce((sum, row) => sum + row.price, 0);
    const avgEarned = data.length > 0 ? totalEarned / data.length : 0;
    const visibleRows = showAll ? data : data.slice(0, INITIAL_ROWS);
    
    return (
        // <p className="text-primary-10 text-xs font-mono mt-2 mb-3">{t('reports.worker_report')}</p>
        <div className="bg-primary-800 border border-primary-50 rounded-2xl p-4 mb-3">
            <div className="flex mb-4 items-center">
                <div className="rounded-xl p-2 text-2xl bg-success-50 text-success-800">
                    <IoDocumentTextOutline />
                </div>
                <div className="ml-2">
                    <h3 className="text-white ">
                    {t('reports.monthly_report')}
                    </h3>
                    <p className="text-primary-10 text-xs">{t('reports.monthly_report_desc')}</p>
                </div>
            </div>
            <FilterToggle
                value={filter}
                dateFrom={dateFrom}
                dateTo={dateTo}
                onChange={onFilterChange}
                onCustomClick={onCustomClick}
                onClearDates={onClearDates}
            />
            {/* Stats Summary */}
            <div className="flex items-center gap-2">
                <div className="w-full bg-background-600 rounded-2xl border border-primary-50 p-2">
                    <p className="text-primary-10 text-xs">HOUSES</p>
                    <p className="text-secondary-800 text-base font-bold">{data.length}</p>
                </div>
                <div className="w-full bg-background-600 rounded-2xl border border-primary-50 p-2">
                    <p className="text-primary-10 text-xs">TOTAL</p>
                    <p className="text-success-800 text-base font-bold">${totalEarned.toFixed(1)}</p>
                </div>
                <div className="w-full bg-background-600 rounded-2xl border border-primary-50 p-2">
                    <p className="text-primary-10 text-xs">AVG PRICE</p>
                    <p className="text-white text-base font-bold">${avgEarned.toFixed(2)}</p>
                </div>
            </div>
            {/* Records table */}
            {!currentUserId ? (
                    <p className="text-primary-10 text-base text-center mt-4">{t('reports.worker_select')}</p>
                ) : (
                    <table className="w-full text-left mt-4 border-spacing-y-4">
                        <thead className="">
                            <tr className="text-primary-10 text-xs border-b border-separate border-primary-50">
                                <th>DATE</th>
                                <th>HOUSE</th>
                                <th>PRICE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visibleRows.map((row, index) => (
                                <tr key={index} className="font-mono text-base">
                                    <td className="text-primary-10">{row.date}</td>
                                    <td className="text-primary-10">{row.house}</td>
                                    <td className="text-success-800">${row.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                {/* Show more/less */}
                {data.length > INITIAL_ROWS && (
                    <button 
                        onClick={() => setShowAll(!showAll)}
                        className="w-full text-center text-primary-50 text-xs font-mono mt-3 py-2 border border-primary-50 rounded-xl">
                            {showAll ? 'SHOW LESS' : `SHOW MORE (${data.length - INITIAL_ROWS} remaining)`}
                    </button>
                )}
            <button className="flex w-full items-center justify-center rounded-xl bg-success-50 text-success-800 text-sm font-bold border border-success-800 mt-3 py-3"
            onClick={onExport}>
                <GoDownload /> {t('reports.export_telegram')}
            </button>
        </div>          
        );
    };

export default MonthlyReportSingle;